import { Range } from 'react-range';

interface MobileAgeFilterProps {
	setSkillRange: (values: number[]) => void;
	rangeValue: number[];
}

export const MobileSkillRange = ({ setSkillRange, rangeValue }: MobileAgeFilterProps) => {
	return (
		<div className="flex flex-col px-4">
			<div className="mb-12 flex-1">
				<Range
					step={0.1}
					min={0}
					max={8}
					allowOverlap={false}
					values={rangeValue.length === 1 ? [Number(rangeValue[0]), 8] : rangeValue}
					onChange={(values) => setSkillRange(values)}
					renderTrack={({ props, children }) => (
						<div {...props} className="h-2 rounded-md bg-darkorange-300">
							{children}
						</div>
					)}
					renderThumb={({ props, value, isDragged }) => {
						const { key, ...restProps } = props;
						return (
							<div key={key} className="focus:outline-none" {...restProps}>
								<span className="absolute left-1/2 top-full mt-1 -translate-x-1/2 px-1 py-0.5">{value.toFixed(1)}</span>
								<div
									className={`size-5 rounded-full shadow-md focus:outline-none
                              ${isDragged ? 'cursor-grabbing' : 'cursor-pointer'}
                              ${isDragged ? 'border-darkorange-600 bg-darkorange-600' : 'border-gray-100 bg-darkorange-600'}`}
								/>
							</div>
						);
					}}
				/>
			</div>
		</div>
	);
};
